<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
    </v-snackbar>
    <v-card class="neu-glow pb-3 mb-5">
      <v-card-title primary-title>
        <div class="text-h5">Tavoli</div>
        <v-spacer></v-spacer>
        <v-div class="mr-n5 mt-1">
          <!--
            <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow" :loading="loading_update"  :disabled="activeTables_hash==JSON.stringify(activeSlots)" @click.stop="saveActiveTables()">
                <v-icon color="error">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>-->
          <!--
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="editTable(hallId,'','addRow')">
                  <v-icon color="info">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Aggiungi Riga</span>
            </v-tooltip> 
            -->           
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                <v-icon color="info">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>                
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                <v-icon color="info">mdi-sync-circle</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>                                     
        </v-div> 
      </v-card-title>
      <v-row v-if="!allLocations">
          <v-col class="text-center mx-8">
            <v-progress-linear
              color="info"
              height="10"
              indeterminate
              striped
            ></v-progress-linear>
          </v-col>
      </v-row>
      <v-row v-else class="mx-3">
        <v-card class="neu-glow mt-2">
          <v-tabs
            color="info"
            elevation="8"
            v-model="hallId"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tabs-slider color="info"></v-tabs-slider>
            <template v-for="(h,hi) in allHalls" >
              <v-tab
                :key=hi
                :href="'#'+h.hallId"
                class="font-weight-bold"
              >
                {{h.text}}
              </v-tab>
              <v-tab-item :key=h :id="h.hallId" class="mt-3 mx-4 mb-4 pt-3 pl-3">
                <v-row class="d-flex pr-3">
                  <template v-for="(t,ti) in thisHall">
                    <div :key="ti">{{t.cols}}</div>
                    <v-col elevation="5" class="px-1 py-2" :key="ti">
                      <v-text-field
                        dense
                        style="min-height:30px"
                        :placeholder="t.name"
                        persistent-placeholder
                        outlined
                        loader-heigth="5"
                        :loading="loading_update"
                        :background-color="t.name?(t.show?'success lighten-3':'error lighten-3'):''"
                        v-model="currentHall[ti].name"
                        hide-details
                        class="my-n1 px-0"
                        @change="editTable(t,ti)"
                      >
                        <v-icon slot="append" class="pl-1" :color="t.show?'success':'error'" :small="$vuetify.breakpoint.smAndUp" v-show="t.name" @click="editTable(t,ti,'hide')">
                            {{!t.name?'':t.show?'mdi-check-circle':'mdi-close-circle'}}
                        </v-icon> 
                      </v-text-field>
                    </v-col>
                    <v-responsive v-if="(ti+1)%parseInt(h.cols) === 0" :key="ti" width="100%"></v-responsive>
                  </template>
                </v-row>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>
      </v-row>
    </v-card>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-1">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>             
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
                <v-col md="6" cols="12">
                    <p>
                        Inserite il numero del tavolo nelle celle in modo da rispecchiare al meglio la disposizione dei tavoli nella sala.
                    </p>
                    <p>
                      Uscendo dalla cella questa diventa verde e significa che quel tavolo è attivo: Il dato è già stato salvato nel dataBase e non vi è un pulsante "salva" da cliccare
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Per disattivare un tavolo basta cliccare sull'icona rossa all'interno della cella: la cella stessa diventa rossa ed il tavolo è disattivato
                    </p>
                    <p>
                      Per eliminare un tavolo basta entrare nella cella, cancellarne il contenuto ed uscire: anche in questo caso il dato è già stato salvato nel dataBase e non vi è un pulsante "salva" da cliccare
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      allTables:null,
      allHalls:null,
      locationId:null,
      hallId:null,
      currentHall:null,
      tableId:null,
      allLocations:null,
      allTables_hash:null,
      message:null,
      snackbar_color:null,
      snackbar:null,
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    thisHall(){
      console.log(186,this.locationId,this.hallId);
      this.currentHall=this.allTables.filter(t =>t.hallId===this.hallId)
      console.log(188,this.currentHall);
      return this.currentHall
    }
  },
  beforeUnmount()
  {
      alert("leaving")
      console.log(187,'leaving')
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
    async editTable(t,ti,action='')
    {
      console.log(199,t.show)
      this.loading_update='red';
      //oldTables=JSON.parse(this.allTables_hash);
      var dt={...t};
      if (action=='hide')
      {
        dt.show=!dt.show;
      }
      else if(action=='')
      {
        dt.show=dt.name!='';
      }
      var table=action=='addRow'?'TablesAddRow':'EnableTables';
      console.log(202,t,ti,t.show)

      let payload={"action":"saveItem","table":table,"payload":dt};
      console.log(205,payload)
      let w= await this.updateDB(payload)
      this.loading_update=false;
      console.log(208,w);
      switch(w.errorid)
      {
          case '0':
            if (w.status=='OK')
            {
              if (action=='hide')
              {
                t.show=!t.show;
              }
              else if(action=='')
              {
                t.show=t.name!='';
              }
            }
            this.snackbar_color=w.status=='OK'?'success':'error';
            this.message =w.message;
            this.snackbar = true;
            if (action=='hide')
            {
              //this.allTables.find(ta=>ta.tableId==t.tableId).show=!t.show;
            }
            else if (t.name!=''&&action=='')
            {
              this.allTables.find(ta=>ta.tableId==t.tableId).show=1;
            }
            console.log(216,this.allTables)
        }
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"sortOrder":"sortOrder","action":"AllTables2_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.allLocations=res.data.payloads.allLocations;
                    this.allHalls=res.data.payloads.allHalls;
                    this.allTables=res.data.payloads.allTables;
                    this.allTables_hash=JSON.stringify(this.allTables);
                    console.log(282,this.allLocations,this.allHalls,this.allTables)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>
<style>
.col-20 {
    -ms-flex: 0 0 5%;
    flex: 0 0 5%;
    max-width: 5%;
}
.minh-30{
  min-height:30px!important;
}
.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot{
   min-height:30px!important;
}

</style>